import { render } from "./HelpCenter.vue?vue&type=template&id=5a2ba3ba&scoped=true"
import script from "./HelpCenter.vue?vue&type=script&lang=js"
export * from "./HelpCenter.vue?vue&type=script&lang=js"

import "./HelpCenter.vue?vue&type=style&index=0&id=5a2ba3ba&scoped=true&lang=css"

import exportComponent from "/Users/chris/Sites/my-celestetic/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2ba3ba"]])

export default __exports__